import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Message } from 'primeng/api';
import { StorageService } from '../../../services/system/storage.service';
import { InvoiceTheme } from '../../../models/inModels/InvoiceTheme';
import { InvoiceThemeService } from '../../../services/invoice-theme/invoice-theme.service';

@Component({
  selector: 'app-create-invoice-theme',
  templateUrl: './create-invoice-theme.component.html'
})

export class CreateInvoiceThemeComponent  {
	model: InvoiceTheme;
	loading = false;
	error: Message[];
	messages: Message[];
	constructor(
		public storageService: StorageService,
		private router: Router,
		private service: InvoiceThemeService,) {
		this.model = new InvoiceTheme();
	}

	ngOnInit() {
	}

	goBack(): void {
		this.router.navigate(['/ads-coupons']);
	}

	save() {
		this.loading = true;
		this.service.create(this.model).then(
			result => {
				console.log("The generated coupon ", result);
				this.loading = false;
				this.goBack();
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	handleBackgroundImage(event): void {
		var result = this.storageService.handleSuccess(event);
		this.model.backgroundImage = result.PublicId;
		this.loading = false;
	}


	handleDisplayImage(event): void {
		var result = this.storageService.handleSuccess(event);
		this.model.displayImage = result.PublicId;
		this.loading = false;
	}
		
	handleError(event): void {
		this.loading = false;
		this.error = [];
		this.storageService.handleError(event, this.error);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/invoice-themes/create-invoice-theme/create-invoice-theme.component.ts